import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLegalShell } from '../components/layout/PublicLegalShell';

export default function PrivacyPage() {
  return (
    <PublicLegalShell title="Privacy Policy" eyebrow="Trust & legal">
      <p>
        Your archive is private by default. We do not sell your family information. You control invites, memorial
        visibility, and exports.
      </p>
      <p>
        MyLegacyBridge is built for personal family archiving. Content you upload remains yours. We use your information
        only to provide the service — not for advertising profiles or resale.
      </p>
      <section id="data" className="scroll-mt-24">
        <h2 className="font-serif text-xl font-normal text-[hsl(24_14%_16%)]">Data deletion &amp; privacy requests</h2>
        <p className="mt-3">
          You can delete individual content from your archive or request full account deletion. Email{' '}
          <a href="mailto:support@mylegacybridge.com" className="text-[hsl(38_36%_42%)] underline underline-offset-2">
            support@mylegacybridge.com
          </a>{' '}
          with the address on your account and we will confirm next steps.
        </p>
      </section>
      <p>
        Full policy details will be published before general launch. For questions now, see our{' '}
        <Link to="/faq#privacy" className="text-[hsl(38_36%_42%)] underline underline-offset-2">
          FAQ privacy section
        </Link>{' '}
        or{' '}
        <Link to="/contact" className="text-[hsl(38_36%_42%)] underline underline-offset-2">
          contact us
        </Link>
        .
      </p>
    </PublicLegalShell>
  );
}
